import React from "react";
import { Container, Row, Col } from "reactstrap";
import styles from "./CouponDetail.module.scss";
import GeneralBackButton from "../../../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton";
import InfoCard from "../../../../../common/AdminCommonComponents/InfoCard/InfoCard";
import ColoredHeader from "../../../../../common/AdminCommonComponents/ColoredHeading/ColoredHeader";
import DynamicDatatable from "../../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import DynamicButton from "../../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";

const CouponDetail = () => {
    const generalInfoData = [
        { label: "Coupon ID", value: "#1234" },
        { label: "Coupon Description", value: "Description" },
        { label: "Discount Type", value: "Percentage off" },
        { label: "Discount Value", value: "$50.00" },
        { label: "Status", value: "Active" },
        { label: "Start date", value: "02/01/2025" },
        { label: "End date", value: "04/01/2025" },
    ];

    const conditionsData = [
        { label: "Minimum Order Value", value: "$00.00" },
        { label: "Usage Limit", value: "1" },
        { label: "Target Audience", value: "New Users" },
        { label: "Applicability", value: "Whole platform" },
    ];

    const summaryData = [
        { label: "Total Coupons Issued", value: "0" },
        { label: "Total Coupons Used", value: "0" },
        { label: "Remaining Coupons", value: "0" },
    ];

    const tableData = [
        {
            productName: "Product Name",
            productId: "#1234",
            sku: "SKU124a",
            stock: 1,
            price: "$49.00",
        },
        {
            productName: "Product Name",
            productId: "#1234",
            sku: "SKU124a",
            stock: 1,
            price: "$49.00",
        },
    ];

    const columns = [
        {
            name: "Product Name",
            selector: (row) => row.productName,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Product ID",
            selector: (row) => row.productId,
            center: "true",
            minWidth: "120px",
        },
        {
            name: "SKU",
            selector: (row) => row.sku,
            center: "true",
        },
        {
            name: "Stock",
            selector: (row) => row.stock,
            center: "true",
        },
        {
            name: "Unit Price",
            selector: (row) => row.price,
            center: "true",
            minWidth: "120px",
        },
    ];

    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderDetailWrapper}>
                <GeneralBackButton />
                <h4 className={styles.mainHeading}>Coupon Detail</h4>
                <Row className={styles.infoCardRow}>
                    <Col>
                        <InfoCard title="General Information" headerColor="#FBBD34" data={generalInfoData} />
                    </Col>
                    <Col>
                        <InfoCard title="Conditions" headerColor="#EC7426" data={conditionsData} />
                    </Col>
                    <Col>
                        <InfoCard title="Usage Summary" headerColor="#EC7426" data={summaryData} />
                    </Col>
                </Row>
                <Row className={styles.dataTableRow}>
                    <Col>
                        <ColoredHeader title={"Products Applicable"} headerColor={"#9747FF"} />
                        <DynamicDatatable
                            data={tableData}
                            columns={columns}
                            type="gray"
                            highlightOnHover
                        />
                    </Col>
                </Row>
                <Row className={styles.btnsRow}>
                    <Col className={styles.btnsWrapper}>
                        <DynamicButton theme="gray">Delete Coupon</DynamicButton>
                        <DynamicButton theme="yellow">Edit Coupon</DynamicButton>
                        <DynamicButton theme="sky-blue">Change Status</DynamicButton>
                        <DynamicButton theme="orange">Download Detail</DynamicButton>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default CouponDetail;